import React from 'react';
import { useSelector } from 'react-redux';
import { selectAgroLayoutCurrentTab } from 'redux/reducers/agroLayoutReducer';
import SimilarityControlPanel from 'components/Meteorology/Weather/ControlPanel/Similarity';
import WBSequentialControlPanel from './WaterBalanceSequential';
import WBCultureControlPanel from './WaterBalanceCulture';
import CultureIndexControlPanel from './CultureIndex';
import TrackingForecastDetailedViewControlPanel from './TrackingForecast/DetailedView';

export default function ControlPanel() {
  const currentTab = useSelector(selectAgroLayoutCurrentTab);

  return (
    <div>
      {currentTab === 'water-balance-sequential' && <WBSequentialControlPanel />}
      {currentTab === 'water-balance-culture' && <WBCultureControlPanel />}
      {currentTab === 'culture-index' && <CultureIndexControlPanel />}
      {currentTab === 'agro/trackingforecast/detailedview' && <TrackingForecastDetailedViewControlPanel />}
      {currentTab === 'similarity' && <SimilarityControlPanel />}
    </div>
  );
}
